import { Input as InputPrimitive } from '@base-ui/react/input';
import { cn } from '@mdvip/shared/lib/utils';
import '@mdvip/shared/lib/uiModality';
import type * as React from 'react';

function Input({ className, type, ...props }: React.ComponentProps<'input'>) {
  return (
    <InputPrimitive
      type={type}
      data-slot="input"
      className={cn(
        'h-12 w-full min-w-0 rounded-md border border-input bg-transparent px-2.5 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground disabled:pointer-events-none disabled:cursor-not-allowed disabled:bg-[color-mix(in_oklch,var(--foreground)_8%,var(--background))] disabled:text-muted-foreground aria-invalid:border-destructive aria-invalid:bg-[color-mix(in_oklch,var(--destructive)_8%,var(--card))] md:text-sm dark:bg-input/30 dark:aria-invalid:border-destructive/50',
        className,
      )}
      {...props}
    />
  );
}

export { Input };
